import WorkflowNewEntity from '../workflow/new';


const routes = {
  '/anonymous/:tenant/workflow/:entityType/new': { exact: true, component: WorkflowNewEntity },
};


export default routes;